import React from "react";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { AiTwotoneMail } from "react-icons/ai";
const SocialMedia = () => {
  const handleEmailClick = () => {
    const recipient = "wahaj1020@gmail.com";

    const gmailLink = `https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(
      recipient
    )}`;
    window.open(gmailLink, "_blank");
  };

  return (
    <div className="app__social">
      <div>
        <a
          href="https://www.linkedin.com/in/wahaj-rashid-0a098a214/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          href="https://github.com/WahajRashid1020"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsGithub />
        </a>
      </div>
      <div onClick={handleEmailClick}>
        <AiTwotoneMail />
      </div>
    </div>
  );
};

export default SocialMedia;
